import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type AvailableLanguage = 'fr' | 'en' | 'es' | 'pl';

@Injectable()
export class LanguageService {

  public static AVAILABLE_LANGUAGES: AvailableLanguage[] = [
    'en',
    'fr',
    //'hu',
    'pl',
    //'pt',
    //'ro',
    //'ru',
    //'uk',
    'es',
  ];

  private readonly language = new BehaviorSubject<AvailableLanguage>(null);
  public language$ = this.language.asObservable();

  public getLanguage(): Observable<AvailableLanguage> {
    return this.language$;
  }

  public getCurrentLanguage(): AvailableLanguage | null {
    return this.language.getValue();
  }

  public setLanguage(language?: AvailableLanguage): void {
    this.language.next(language);
  };
}
